// Pure helpers to render a live room feed cleanly: dedupe by id, keep the
// freshest copy, and order by seq (fallback created_at). This prevents visible
// duplicates and out-of-order agent banter/loops. The server remains the source
// of truth — we never synthesize messages here.

export function dedupeAndOrder(messages) {
  const list = Array.isArray(messages) ? messages : [];
  const byId = new Map();
  for (const m of list) {
    if (!m) continue;
    const id = m.id ?? m._id ?? (m.seq != null ? `seq:${m.seq}` : null);
    if (id == null) continue;
    byId.set(String(id), m); // later occurrence wins (server copy over optimistic)
  }
  return Array.from(byId.values()).sort((a, b) => {
    const sa = a.seq, sb = b.seq;
    if (typeof sa === "number" && typeof sb === "number" && sa !== sb) return sa - sb;
    const ta = Date.parse(a.created_at || a.ts || "") || 0;
    const tb = Date.parse(b.created_at || b.ts || "") || 0;
    return ta - tb;
  });
}

// Highest sequence number present (used to decide whether to auto-scroll).
export function maxSeqOf(messages) {
  const list = Array.isArray(messages) ? messages : [];
  return list.reduce((m, x) => Math.max(m, (x && typeof x.seq === "number") ? x.seq : 0), 0);
}

// Whether the scroll viewport is near the bottom (so we only stick-to-bottom
// when the reader is already following the live feed, preserving their scroll
// position otherwise).
export function isNearBottom(el, threshold = 120) {
  if (!el) return true;
  return el.scrollHeight - el.scrollTop - el.clientHeight <= threshold;
}
